import React, { createContext, useContext, useState, useCallback } from 'react';
import api from '../../api/client';

const SuperAdminContext = createContext(null);

export function SuperAdminProvider({ children }) {
  const [user, setUser] = useState(() => {
    const stored = localStorage.getItem('sa_user');
    return stored ? JSON.parse(stored) : null;
  });
  const [token, setToken] = useState(() => localStorage.getItem('sa_token'));

  const login = useCallback(async (email, password, captcha_token) => {
    const { data } = await api.post('/api/super-admin/login', { email, password, captcha_token });
    localStorage.setItem('sa_token', data.access_token);
    localStorage.setItem('sa_user', JSON.stringify(data.user));
    setToken(data.access_token);
    setUser(data.user);
    return data;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('sa_token');
    localStorage.removeItem('sa_user');
    setToken(null);
    setUser(null);
  }, []);

  const saApi = useCallback((method, url, data, config) => {
    const t = localStorage.getItem('sa_token');
    return api({ method, url, data, headers: { Authorization: `Bearer ${t}`, ...(config?.headers || {}) } });
  }, []);

  return (
    <SuperAdminContext.Provider value={{ user, token, login, logout, saApi, isAuthenticated: !!token }}>
      {children}
    </SuperAdminContext.Provider>
  );
}

export const useSuperAdmin = () => useContext(SuperAdminContext);
